import Vue from 'vue'
import index from './privacy.vue'
import '@assets/js/common.js'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(index)
})
